<template>
  <div class="mask wh100 pf flex_center">
    <div class="newVersion_wrap white pr">
      <i class="el-icon-circle-close versionClose cf pointer pa" @click="closeVersion" />
      <img src="@/assets/newVersion_head.png" alt="" class="pa">
      <el-divider content-position="center"><span class="fs20 bold">版本功能点</span></el-divider>
      <div class="newVersion_content" v-html="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeVersion() {
      this.$emit('Close', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.mask{
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  .newVersion_wrap{
    width: 482px;
    height: 490px;
    border-radius: 10px;
    .versionClose{
      font-size: 30px;
      top: -13px;
      right: -13px;
      z-index: 1;
    }
    img{
      top: -42px;
    }
    .el-divider--horizontal{
      width: 60%;
      margin: 170px auto 35px;
    }
    .newVersion_content{
      height: 260px;
      overflow: auto;
      padding: 0 40px;
    }
  }
}
</style>
